<script>
import Utility from '@/common/UtilityFunctions.js';

export default {
  methods: {
    getTitleForVM() {
      if (this.vueModel?.CreateClaimStep1Model?.StepTitle && this.index === 1) {
        return this.vueModel.CreateClaimStep1Model.StepTitle.toLowerCase();
      }
      if (this.vueModel?.CreateClaimStep2Model?.StepTitle && this.index === 2) {
        return this.vueModel.CreateClaimStep2Model.StepTitle.toLowerCase();
      }
      if (this.vueModel?.CreateClaimStep3Model?.StepTitle && this.index === 3) {
        return this.vueModel.CreateClaimStep3Model.StepTitle.toLowerCase();
      }
      if (this.vueModel?.CreateClaimStep4Model?.StepTitle && this.index === 4) {
        return this.vueModel.CreateClaimStep4Model.StepTitle.toLowerCase();
      }
      return '';
    },
    getDamageCodeVORefValues() {
      const eventLabel = Utility.getCookieValue('question-tree-create-claim-tracking-event-label');
      if (eventLabel) {
        return eventLabel;
      }
      return '';
    },
    getDamageCodeVORefValuesDescription () {
      if (this.vueModel?.CreateClaimEntity?.DamageCodes) {
        return this.vueModel?.CreateClaimEntity?.DamageCodes.map((item) => item.DamageCodeVORefValue).join('|').toLowerCase();
      }
      return 'simple_flow';
    },
    getDamageCodeVORefIds() {
      if (this.vueModel?.CreateClaimEntity?.DamageCodes) {
        return this.vueModel?.CreateClaimEntity?.DamageCodes.map((item) => item.DamageCodeVORefId).join(',');
      }
      return 'simple_flow';
    },
    getStartTimestamp() {
      const startTime = Utility.getCookieValue('question-tree-create-claim-tracking-start-time');
      if (startTime) {
        return startTime;
      }
      return '';
    },
    getTrackingVM(isCloseAction) {
      return {
        index: this.index,
        product: Utility.getShortPolicyName(this.vueModel.CreateClaimEntity.ProductName),
        step: 'step_' + this.index,
        title: this.getTitleForVM(),
        action: isCloseAction ? 'step_close_form' : 'step_' + this.index,
        damageCodeVORefValues: this.getDamageCodeVORefValues(),
        damageCodeVORefValuesDescription: this.getDamageCodeVORefValuesDescription(),
        productId: this.vueModel.CreateClaimEntity.ProductId.toString(),
        damageCodeVORefIds: this.getDamageCodeVORefIds(),
        startTimestamp: this.getStartTimestamp()
      };
    },
    deleteCookies() {
      Utility.deleteCookie('question-tree-create-claim-tracking-event-label');
      Utility.deleteCookie('question-tree-create-claim-tracking-start-time');
    },
    dispatchEventWithCloseFormAction(isCloseAction) {
      if (this.currentModel === null) {
        return;
      }

      this.$store.dispatch('Events/register', {
        event: 'create-claim-step-' + this.index,
        id: 'reportClaim',
        vm: {
          ...this.getTrackingVM(isCloseAction),
        }
      });

      if (isCloseAction) {
        return this.deleteCookies();
      }
      return;
    },
    dispatchEventObjWithCloseFormAction(trackingVm, isCloseAction) {
      if (this.currentModel === null) {
        return;
      }

      this.$store.dispatch('Events/register', {
        event: 'create-claim-step-' + this.index,
        id: 'reportClaim',
        vm: {
          ...trackingVm,
          action: isCloseAction ? 'step_close_form' : 'step_' + trackingVm.index,
        }
      });

      if (isCloseAction) {
        return this.deleteCookies();
      }
      return;
    },
    dispatchEventObjWithApiError(trackingVm, message) {
      return this.$store.dispatch('Events/register', {
        event: 'create-claim-flow-api-error',
        id: 'reportClaim',
        vm: {
          ...trackingVm,
          apiStatusCode: 418,
          apiErrorMessage: message
        }
      });
    },
    dispatchEventWithApiError(message) {
      return this.$store.dispatch('Events/register', {
        event: 'create-claim-flow-api-error',
        id: 'reportClaim',
        vm: {
          ...this.getTrackingVM(false),
          apiStatusCode: 418,
          apiErrorMessage: message
        }
      });
    },
    dispatchEventWithApiSuccess(trackingVM) {
      this.$store.dispatch('Events/register', {
        event: 'create-claim-flow-api-success',
        id: 'reportClaim',
        vm: {
          ...trackingVM
        }
      });

      return this.deleteCookies();
    },
    dispatchEventWithApiFailure(trackingVM) {
      this.$store.dispatch('Events/register', {
        event: 'create-claim-flow-api-failure',
        id: 'reportClaim',
        vm: {
          ...trackingVM
        }
      });

      return this.deleteCookies();
    },
    populateQuestionnaireAndGoToNext() {
      this.saving = true;

      Utility.post(
        Utility.constants().API.createclaim_getquestionnaire,
        this.vueModel.CreateClaimEntity,
        this.getQuestionnaireSuccess,
        this.getQuestionnaireFail,
        this
      );
    },
    getQuestionnaireSuccess(response) {
      if (response.data.Data !== null) {
        if (this.vueModel.CreateClaimEntity.ProductSpecific.QuestionnaireList === null) {
          this.vueModel.CreateClaimEntity.ProductSpecific.QuestionnaireList =
          response.data.Data.QuestionnaireModels;
        }
      }

      this.saving = false;
      this.index++;
    },
    getQuestionnaireFail(error) {
      this.dispatchEventWithApiError('createclaim_getquestionnaire: ' + error?.message);

      Utility.logError(error, this);

      this.saving = false;
      this.index++;
    }
  }
};
</script>
